import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core'
import { select, Store } from '@ngrx/store'
import {
  Rental,
  selectAllRentals,
  selectRentalsWithoutSubUnits,
  selectRentalsWithoutMainUnits,
  isMainUnit,
  isSubunit,
} from '@tokeet-frontend/tv3-platform'
import { FormControl } from '@angular/forms'
import { Observable, of } from 'rxjs'
import { map } from 'rxjs/operators'

@Component({
  selector: 'app-rental-select',
  templateUrl: './rental-select.component.html',
  styleUrls: ['./rental-select.component.scss'],
})
export class RentalSelectComponent implements OnInit {
  @Input() ctrl: FormControl
  @Input() placeholder = $localize`Select Rentals`
  @Input() label = $localize`Select Rentals`
  @Input() multiple = true
  @Input() set inline(b: boolean) {
    this.showLabel = !b
  }
  @Input() showBlankItem = false
  @Input() infoIcon: string

  @Input() showLabel = true
  @Input() showPlaceholder = true
  @Input() disabled = false
  @Input() set items(items: Rental[]) {
    this.rentals$ = of(items)
  }
  @Input() rentals$: Observable<Rental[]>
  @Input() bindValue: string | ((r: Rental) => any) = 'id'

  @Input() showMasterCheckbox = true
  @Input() showCloseButton = false
  @Input() excludeSubunits = false
  @Input() excludeMainUnits = false
  @Input() excludeDisabledSubunits = false
  @Input() isSelectable: (item: Rental) => boolean
  @Input() getTooltip: (item: Rental) => string | null

  @Output() openedChange = new EventEmitter<boolean>()
  @Output() selectedValuesChange = new EventEmitter<string[]>()
  @Output() selectedItemsChange = new EventEmitter<Rental[]>()

  getRentalLabel = (r: Rental) => r?.nickname || r?.name

  isMainUnit = isMainUnit
  isSubunit = isSubunit

  constructor(private store: Store<any>) {}

  ngOnInit(): void {
    if (!this.rentals$) {
      if (this.excludeMainUnits) {
        this.rentals$ = this.store.pipe(select(selectRentalsWithoutMainUnits))
      } else if (this.excludeSubunits) {
        this.rentals$ = this.store.pipe(select(selectRentalsWithoutSubUnits))
      } else {
        this.rentals$ = this.store.pipe(select(selectAllRentals))
      }
    }
    this.rentals$ = this.rentals$.pipe(
      map((rentals) => rentals?.filter((r) => !this.excludeDisabledSubunits || !isSubunit(r) || !!r.multi_unit_status))
    )
  }
}
